const readFileAsync = file => (
    new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onloadend = (e) => {
            resolve({
                name: file.name,
                type: file.type,
                binary: e.target.result,
            });
        };
        fileReader.onerror = (e) => {
            reject(e);
        };
        fileReader.readAsArrayBuffer(file);
    })
);

const proxyRequest = options => (
    new Promise((resolve, reject) => {
        const endpoint = `${options.endpoint}/${options.action}`;
        const doNotUseProxy = options.doNotUseProxy === true;
        const xhr = new XMLHttpRequest();
        xhr.open(
            options.httpMethod || 'POST',
            // (doNotUseProxy ? 'https://cors-anywhere.herokuapp.com/' : '') +
            // options.endpoint + '/FileUpload'
            doNotUseProxy
                ? `${options.endpoint}/FileUpload`
                : (`${(options.subDomain ? `/${options.subDomain}` : '')}/services/proxy`),
        );
        Object.keys(options.params).forEach((key) => {
            xhr.setRequestHeader(key, encodeURIComponent(options.params[key]));
        });
        // xhr.setRequestHeader('Cookie', "debug_logs=debug_logs; path=/; domain=.force.com; value=debug_logs");
        xhr.setRequestHeader('Authorization', 'Bearer ');
        xhr.setRequestHeader('SalesforceProxy-Endpoint', endpoint);
        xhr.setRequestHeader('X-User-Agent', 'FileUpload v1.0');
        xhr.setRequestHeader('ContentType', 'application/json');
        if (options.sessionId) {
            xhr.setRequestHeader(`Authorization, Bearer ${options.sessionId}`);
        }
        xhr.responseType = 'json';
        xhr.onload = (event) => {
            /* eslint-disable no-console */
            console.log(event);
            /* eslint-disable no-console */
            console.log('remoteFinish');
            let response = event.target.response;
            try {
                response = JSON.parse(event.target.response);
            } catch (e) {
                /* eslint-disable no-console */
                console.log(e);
            }
            const success = event.target.readyState === 4 && event.target.status === 200;
            if (options.onFinish) {
                options.onFinish(options, success);
            }
            if (success) {
                resolve(response);
            } else {
                const data = { error: { message: event.target.response } };
                reject(event);
                /* eslint-disable no-console */
                console.log('remoteError', data, event);
            }
        };
        xhr.upload.onprogress = (e) => {
            const total = e.totalSize || e.total;
            const done = e.position || e.loaded;
            const percent = Math.floor(done / total * 100);
            if (options.onProgress) {
                options.onProgress(options, percent, e, done);
            }
            // setTimeout(function () {
            //  $rootScope.$broadcast('progressFileUpload', {file: file, progress: percent});
            // }, 1);
            /* eslint-disable no-console */
            console.log(`${e}, ${percent}%`);
        };
        if (options.onStart) {
            options.onStart(options);
        }
        /* eslint-disable no-console */
        console.log('remoteStart');
        xhr.send(options.data);
    })
);
const upload = (parentId, file, payload = {}) => {
    const endpoint = `${window.salesforceEndpoint}/services/apexrest`;
    let uploadDataBlob;
    if (file.binary !== undefined) {
        // file = new File([new Uint8Array(file.binary)], file.name, {type: file.type});
        uploadDataBlob = new Blob([new Uint8Array(file.binary)]);
    }
    payload.parentId = parentId;
    payload.file = file;
    return new Promise((resolve, reject) => {
        proxyRequest(
            {
                endpoint,
                httpMethod: 'POST',
                action: 'FileUpload',
                data: uploadDataBlob,
                params: {
                    fileName: file.name,
                    parentId,
                },
                file,
                doNotUseProxy: payload.doNotUseProxy,
                onStart: (options) => {
                    /* eslint-disable no-console */
                    console.log('onStart', options);
                },
                onProgress: (options, percent, e) => {
                    /* eslint-disable no-console */
                    console.log('onProgress', options, percent, e);
                },
                onFinish: (options, success) => {
                    /* eslint-disable no-console */
                    console.log('onFinish', options, success);
                },
            },
        ).then((result) => {
            /* eslint-disable no-console */
            console.log('success', result);
            resolve({
                result,
                payload,
            });
        }, (error) => {
            /* eslint-disable no-console */
            console.log('error', error);
            /* eslint-disable prefer-promise-reject-errors */
            reject({
                error,
                payload,
            });
            /* eslint-disable no-console */
            console.error(JSON.stringify(error.currentTarget.response));
        });
    });
};
const uploadMany = (filesMap, payload) => {
    const uploads = [];
    Object.keys(filesMap).forEach((parentId) => {
        const files = filesMap[parentId];
        for (let i = 0; i < files.length; i += 1) {
            const file = files[i];
            uploads.push(
                readFileAsync(file).then(fileWrapper => upload(parentId, fileWrapper, payload)),
            );
        }
    });
    return Promise.all(uploads);
};
/* eslint-disable no-unused-vars */
export default (parentId, uploaderSelector = '.js-file-upload input') => {
    const fileUploadFields = Array.from(document.querySelectorAll(uploaderSelector));
    const uploads = [];
    fileUploadFields.forEach((fileUpload) => {
        if ('files' in fileUpload) {
            const filesMap = {};
            filesMap[parentId] = fileUpload.files;
            uploads.push(uploadMany(filesMap, { doNotUseProxy: true }));
        }
    });
    return Promise.all(uploads);
};
